import { Drawer, DrawerContent } from '@/shared/components/ui/Drawer';
import { Button } from '@/shared/components/ui/Button';
import { X } from 'lucide-react';
import { FeedbackContent } from './FeedbackContent';
import { useLanguage } from '@/shared/contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

interface FeedbackReviewDrawerProps {
  isOpen: boolean;
  feedbackId: string;
  onClose: () => void;
}

export const FeedbackReviewDrawer = ({
  isOpen,
  feedbackId,
  onClose,
}: FeedbackReviewDrawerProps) => {
  const { isRTL } = useLanguage();
  const { t } = useTranslation('common');

  return (
    <Drawer
      open={isOpen}
      onOpenChange={(open) => !open && onClose()}
      direction={isRTL ? 'left' : 'right'}
    >
      <DrawerContent className="h-full w-full">
        <div className="sticky top-0 z-10 border-b bg-white px-6 py-4">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold">{t('feedbackReview')}</h2>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="gap-2"
            >
              <X className="h-4 w-4" />
              {t('close')}
            </Button>
          </div>
        </div>

        <div className="h-[calc(100vh-5rem)] overflow-y-auto">
          <FeedbackContent feedbackId={feedbackId} />
        </div>
      </DrawerContent>
    </Drawer>
  );
};
